import { createWire } from '@forminator/react-wire'

export const counties = createWire([])

export const currentCounty = createWire(null)